<div class="filter-container">
	<feature-porto-bank-categories-cuisines></feature-porto-bank-categories-cuisines>
	<feature-porto-bank-cities
		[cities]="(cities$ | async) ?? []"
		[selectedCity]="(selectedCity$ | async) ?? undefined"
		(citySelected)="onCitySelected($event)"
	></feature-porto-bank-cities>
</div>

<div class="search-input">
	<mat-icon
		class="search-icon"
		svgIcon="porto-bank-icons:search"
		style="width: 20px; height: 20px; cursor: pointer"
		(click)="searchInput.focus()"
	></mat-icon>
	<input type="text" placeholder="Buscar restaurantes" [formControl]="searchControl" #searchInput />
</div>
